module.exports = __webpack_public_path__ + "img/register-v2-dark.cd7ac573.svg";